var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"GUIDE","name":"GUIDE","data-vcode":"GUIDE"}},[_c('img',{staticClass:"soft-img",attrs:{"src":"/images/icons/ic_grid_white_56.svg","alt":"","role":"img","aria-hidden":"true"}}),_c('label',[_vm._v(" "+_vm._s(_vm.$t('guideButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }